import { z } from "zod";
import { AuditTrailEntryType } from "../AuditTrailEntryType.js";
// Section 132 audit `data` schemas. See `registry.ts` for the audit-data leniency
// contract these follow.
//
// Free text (reasons, notes, who gave the information) is deliberately not
// audited: audit rows are immutable, so an entry later withdrawn as recorded
// against the wrong patient would leave that patient's detail in this one's
// log for good.
const attemptFacts = {
    attemptId: z.string(),
    section: z.string().nullish(),
    outcome: z.string().nullish(),
    occurredAt: z.string().nullish(),
    writtenInformationGiven: z.boolean().nullish(),
    deliveredBySomeoneElse: z.boolean().nullish(),
};
export const recordS132AttemptDataSchema = z.object(attemptFacts);
export const correctS132AttemptDataSchema = z.object({
    ...attemptFacts,
    supersedesId: z.string().nullish(),
});
export const withdrawS132AttemptDataSchema = z.object({
    attemptId: z.string(),
    section: z.string().nullish(),
    reason: z.string().nullish(),
});
export const s132AuditDataRegistry = {
    [AuditTrailEntryType.viewS132Record]: z.object({}),
    [AuditTrailEntryType.recordS132Attempt]: recordS132AttemptDataSchema,
    [AuditTrailEntryType.correctS132Attempt]: correctS132AttemptDataSchema,
    [AuditTrailEntryType.withdrawS132Attempt]: withdrawS132AttemptDataSchema,
};
//# sourceMappingURL=s132.js.map